module.exports = __webpack_public_path__ + "assets/img/bfaa-us.svg";